import { mergeAttributes, Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import { DOMOutputSpec } from 'prosemirror-model';
import CTAView from '@/components/UI/Editor/CTA/CTAView.vue';
import { DUNNING_DEFAULT_CTA_TEXT } from '@/store/shared';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    cta: {
      insertCta: () => ReturnType;
    };
  }
}

export default Node.create({
  name: 'cta',
  group: 'inline',
  draggable: true,
  atom: true,
  inline: true,
  // content: 'inline*', // This was breaking everything!
  contenteditable: false,
  addAttributes() {
    return {
      text: {
        default: DUNNING_DEFAULT_CTA_TEXT,
      },
      open: {
        default: false,
      }
    }
  },
  addCommands() {
    return {
      insertCta: () => ({ commands }) => {
        const type = this.name;
        const attrs = { text: DUNNING_DEFAULT_CTA_TEXT };
        return commands.insertContent({
          type,
          attrs,
        });
      }
    }
  },
  parseHTML() {
    return [
      {
        tag: 'cta',
        getAttrs: (dom: any) => {
          const result = {
            text: dom.getAttribute('text'),
            open: dom.getAttribute('open'),
          };
          return null;
        },
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    const content = `[[${HTMLAttributes.text}]]`; // [[Call To Action]]
    return ['cta', mergeAttributes(HTMLAttributes), content] as DOMOutputSpec;
  },
  addNodeView() {
    return VueNodeViewRenderer(CTAView);
  },
});

